/* Liberty Stamp Co. — small progressive-enhancement helpers (no dependencies).
   - quantity steppers on product cards
   - homepage theme filter tabs (client-side, by product tag)
   - placeholder "Add to cart" feedback (preview only, when no real product)
   - collection sort dropdown + "Clearance" nav highlight
   Cart drawer opening is native Dawn (cart-drawer.js binds #cart-icon-bubble); no custom handler here. */
(function () {
  'use strict';

  function clampQty(n) { n = parseInt(n, 10); return (isNaN(n) || n < 1) ? 1 : n; }

  document.addEventListener('click', function (e) {
    // ---- quantity stepper ----
    var step = e.target.closest('.lsc-qty__inc, .lsc-qty__dec');
    if (step) {
      var wrap = step.closest('.lsc-qty');
      var input = wrap && wrap.querySelector('.lsc-qty__num');
      if (input) {
        var n = clampQty(input.value);
        if (step.classList.contains('lsc-qty__inc')) n++;
        else if (n > 1) n--;
        input.value = n;
        var card = step.closest('.lsc-card');
        var link = card && card.querySelector('.lsc-add[data-base-url]');
        if (link) {
          var base = link.getAttribute('data-base-url');
          link.href = base + (base.indexOf('?') > -1 ? '&' : '?') + 'quantity=' + n;
        }
      }
      return;
    }

    // ---- theme filter tabs (scoped to the section's grid) ----
    var tab = e.target.closest('.lsc-filters button');
    if (tab) {
      var bar = tab.closest('.lsc-filters');
      var scope = bar.closest('.lsc-collection') || document;
      var grid = scope.querySelector('.lsc-grid, .lsc-pgrid');
      if (!grid) return;
      bar.querySelectorAll('button').forEach(function (b) {
        b.classList.remove('active'); b.setAttribute('aria-pressed', 'false');
      });
      tab.classList.add('active'); tab.setAttribute('aria-pressed', 'true');
      var f = (tab.getAttribute('data-filter') || 'all').toLowerCase().trim();
      grid.querySelectorAll('.lsc-card').forEach(function (c) {
        var tags = (c.getAttribute('data-tags') || '').toLowerCase();
        var list = tags.split(',').map(function (t) { return t.trim(); });
        c.style.display = (f === 'all' || list.indexOf(f) > -1) ? '' : 'none';
      });
      return;
    }

    // ---- placeholder add (preview only) ----
    var ph = e.target.closest('.lsc-add[data-placeholder]');
    if (ph) {
      e.preventDefault();
      var label = ph.textContent;
      ph.textContent = 'Added ✓';
      setTimeout(function () { ph.textContent = label; }, 1100);
    }
  });

  // ---- collection sort dropdown (native ?sort_by=) ----
  document.addEventListener('change', function (e) {
    var sort = e.target.closest && e.target.closest('[data-lsc-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  // keep typed quantities numeric
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('lsc-qty__num')) {
      var v = e.target.value.replace(/[^0-9]/g, '');
      e.target.value = v === '' ? '' : String(clampQty(v));
    }
  });

  // ---- highlight a "Clearance" nav item in coral (header menu is admin-driven) ----
  function lscHighlightClearance() {
    var items = document.querySelectorAll('.header__menu-item, .menu-drawer__menu-item');
    for (var i = 0; i < items.length; i++) {
      var t = (items[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === 'clearance') items[i].classList.add('lsc-nav-clearance');
    }
  }
  if (document.readyState !== 'loading') lscHighlightClearance();
  else document.addEventListener('DOMContentLoaded', lscHighlightClearance);
})();
